import { useEffectOnce } from 'react-use';
import { useBlockFlags } from '@ContractBuilder/modules/block/context/context';
import { BlockContentDeleted } from '@ContractBuilder/modules/block-content/views/BlockContentDeleted';
import { ctxIsPDF } from '@ContractBuilder/rules/block/is-ctx';
import { InlineBlockEditController } from '@features/inline-block-edit';
import { VariationsSelectorLiteController } from '@features/variations-tabs';
import { useSyncVariationInView } from '@providers/variations-tabs';
import { isEndorsementViewPath } from '@utils/app-paths';

import { BlockContent } from '../views/BlockContent';

export const BlockContentController = () => {
  const {
    block,
    isHighlighted,
    context,
    mentionValues,
    details: {
      hasBeenMovedByRenewal,
      isParentEntityEditable,
      isVisible,
      isEditing,
      variations: { count },
    },
  } = useBlockFlags();

  const isPDFRender = ctxIsPDF(context);

  const isEndorsementView = isEndorsementViewPath();
  const syncVariationInView = useSyncVariationInView();

  useEffectOnce(() => {
    syncVariationInView(block);
  });

  if (isEditing) {
    return <InlineBlockEditController />;
  }

  if (!isEndorsementView && !isPDFRender && isVisible && count) {
    return <VariationsSelectorLiteController block={block} />;
  }

  if ((isEndorsementView || isPDFRender) && block?.isDeleted) {
    return <BlockContentDeleted block={block} isHighlighted={isHighlighted} isPdfRender={isPDFRender} />;
  }

  return (
    <BlockContent
      block={block}
      disableMentionHighlight={!isParentEntityEditable && !isPDFRender}
      hasBeenMovedByRenewal={hasBeenMovedByRenewal}
      mentionValues={mentionValues}
      isEditing={isEditing}
      isHighlighted={isHighlighted}
      isInCreateMode={isEditing && !block?.id}
      isPdfRender={isPDFRender}
      isVisible={isVisible}
      showEndorsementDiff={isEndorsementView}
    />
  );
};
